import React from 'react'

const AssistantIcon = ({ assistantValue, size = 40 }) => {
    let src;

    try {
        src = require(`../assets/icons/${assistantValue}.png`)
    } catch {
        src = ''
    }

    return (
        <img src={src} alt={assistantValue + '.png'} width={size} height={size} />
    )
}

export default AssistantIcon